import EmptyLeg from 'pages/home/components/EmptyLeg';
import React from 'react';

// import LeftLogoSVG from 'assets/imgs/svg/home/fly-airtaxi-left.svg';
// import RightLogoSVG from 'assets/imgs/svg/home/fly-airtaxi-right.svg';
import Footer from 'components/layout/Footer';
import styled from 'styled-components';
import Banner from './components/Banner';
// import Blog from './components/Blog';
import Membership from './components/Membership';
// import PetFriendlyFlights from './components/PetFriendlyFlights';
// import Testimonial from './components/Testimonial';

import { HomeMain } from './Home.style';
import Desc from 'pages/home/components/Desc';
import Book from 'pages/home/components/Book';
import PreferredJetCard from 'pages/home/components/PreferredJetCard';
import CustomersFeedback from 'pages/home/components/CustomersFeedback';
import PrecisionDetail from 'pages/home/components/PrecisionDetail';
import NewBlog from 'pages/home/components/NewBlog';
import { vw } from 'components/common/Common';

export const BannerSection = styled.div`
  width: 100%;
  --banner-height: 80vh;
  @media (max-width: 737px) {
    --banner-height: 497px;
  }
  position: relative;
  height: var(--banner-height);
`;

// const BackgroundSection = styled.div`
//   @media (min-width: 1600px) {
//     background: ${(props) =>
//       props.$left
//         ? `#fff url(${LeftLogoSVG}) no-repeat left top`
//         : `#fff url(${RightLogoSVG}) no-repeat right top`};
//   }
// `;

export const LogoContainer = styled.div`
  width: 100%;
  padding: ${vw(40)} ${vw(60)};
  background: #0e1e36;
  display: flex;
  justify-content: center;
`;

export const LogoImg = styled.img`
  width: var(--home-section-width);
`;

const LargeAircraft = styled.img`
  width: 100%;
  object-fit: cover;
  margin: 100px 0;
`;

const Home = () => {
  console.log(`v${process.env.REACT_APP_VERSION || '2.9.1.8-09.21'}`);

  return (
    <HomeMain>
      <BannerSection>
        <Banner />
      </BannerSection>
      <LogoContainer>
        <LogoImg src={`${process.env.REACT_APP_ASSET_URL}/logos/logos.webp`} alt="logos"></LogoImg>
      </LogoContainer>

      <Desc />

      {/* <PetFriendlyFlights /> */}
      <EmptyLeg />

      <Book />

      <PreferredJetCard />

      <Membership />

      <CustomersFeedback />

      <LargeAircraft
        src="/imgs/webp/home/large-aircraft.webp"
        alt="image of a luxury private jet against a blue sky"
      />

      <PrecisionDetail />

      {/* <BackgroundSection $left>
        <Testimonial />
        <Blog />
      </BackgroundSection> */}

      <NewBlog />

      <Footer />
    </HomeMain>
  );
};

export default Home;
